import { useRoutes, Navigate } from "react-router-dom";
import Login from "../auth/Login";
import { ROUTE_CONFIG } from "../config/routeConfig";


export const useAppRoutes = (isLoggedIn, permissions) => {

    if (!isLoggedIn) {
        return useRoutes([
            { path: "/", element: <Login /> },
            { path: "*", element: <Navigate to="/" replace /> },
        ]);
    }

    const allowedRoutes = ROUTE_CONFIG.filter(
        (route) => permissions?.[route.module_name]?.view === true
    );

    return useRoutes([
        ...allowedRoutes,
        { path: "*", element: <Navigate to="/" replace /> },
    ]);
};